export enum ProvisionTypes {
    RDE = 'RDE',
    W10 = 'W10'
}
export enum ProvisionTypesId {
    RDE = 0,
    W10 = 3
}
